import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

export class ChangeExpiry {
    currentExpiryDate : string;
    plan : string;
    planId : string;
    remarks : string;
    revisedExpiryDate : string;
    service : string;
}

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class ChangeExpiryService {
  constructor(private http: HttpClient) {}

  getChnageExpiry(custId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getExpiry/' + custId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res as ChangeExpiry[]),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  insertChangeExpiry(changeExpiry_data : any) : Observable<any> {
      const post_url = baseApiUrl + 'subscriber/changeExpiry';
      return this.http.post<any>(post_url, changeExpiry_data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
    }
}